"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(url) {
  var i = document.createElement("iframe");
  i.style.display = "none";
  i.src = url;
  return new Promise(function (resolve, reject) {
    i.onload = function () {
      resolve();
    };

    i.onerror = function () {
      reject();
    };

    document.body.appendChild(i);
  }).then(function () {
    i.parentNode.removeChild(i);
  });
};

exports["default"] = _default;